import { useParams, useRoutes } from "../../helpers/tixxt-router";
import { useGroup } from "../../hooks/useGroup";
import GroupNavigation from "./GroupNavigation";
import { GroupNavigationPortal } from "./portals";

/* This is used together with the backbone marionette frontend */
export default function TixxtGroupNavigation() {
  const params = useParams();
  const groupSlug = params.group_slug || params.groupSlug || params.group_id;

  if (groupSlug) return <GroupNavigation groupSlug={groupSlug} />;

  return null;
}

/* This is used to render the group navigation on backend rendered pages */
export function StaticTixxtGroupNavigation() {
  return useRoutes([
    { path: "/groups/:groupSlug", element: <PortaledGroupNavigation /> },
    { path: "/groups/:groupSlug/*", element: <PortaledGroupNavigation /> },
  ]);
}

function PortaledGroupNavigation() {
  const { groupSlug } = useParams();
  const { data: group } = useGroup(groupSlug);

  // The externally visible stream (activitystreams/external_show) is read-only
  // and must not show the group navigation. That page is only ever reached by
  // people who are not members, so the check is membership — not visibility
  // (#247): members of an externally visible group need their navigation like
  // everyone else. `my_groups` holds exactly the groups the current member
  // belongs to and is empty for anonymous visitors. Render by default while
  // the group is still unknown; nothing leaks that way:
  // groups/navigation.json.ruby builds the items per permission and membership.
  const isMember = Preload.my_groups?.some((g) => g.slug === groupSlug);

  if (group?.externally_visible && !isMember) return null;

  return (
    <GroupNavigationPortal>
      <TixxtGroupNavigation />
    </GroupNavigationPortal>
  );
}
